const info = {
  ZH: { //中文翻译
    type: "VOC",
    vocReport: "\u68C0\u6D4B\u62A5\u544A",
    vocProject: "\u9879\u76EE",
    odor: "\u6C14\u5473\u6027\u7ED3\u679C",
    comfortability: "\u8212\u9002\u6027\u7ED3\u679C",
    smellType: "\u6C14\u5473\u7C7B\u578B",
    vocMaterialSmell: "\u6C14\u5473",
    condensation: "\u51B7\u51DD\u503C",
    atomization: "\u96FE\u5EA6",
    vocMaterialAtomization: "\u96FE\u5316",
    vocCode: "\u62A5\u544A\u7F16\u53F7",
    vocOrg: "\u68C0\u6D4B\u673A\u6784",
    createDate: "\u751F\u4EA7\u65E5\u671F",
    sendDate: "\u9001\u6837\u65E5\u671F",
    checkDate: "\u68C0\u6D4B\u65E5\u671F",
    checkRule: "\u68C0\u6D4B\u89C4\u5219",
    checkResult: "\u68C0\u6D4B\u7ED3\u679C",
    analysis: "\u4E0A\u4F20",
    voc: "VOC",
    component: " \u96F6\u90E8\u4EF6",
    semiComponent: " \u534A\u6210\u54C1\u4EF6",
    material: " \u6750\u6599",
    subsName: " \u7269\u8D28\u540D\u79F0",
    estimatedValue: " \u68C0\u6D4B\u503C",
    unit: " \u5355\u4F4D",
    upload: "\u6D4F\u89C8",
    upload: "\u4E0A\u4F20",
    /*菜单-VOC物质种类管理*/
    index: "序号", // No.
    subName: "物质名称",
    subEname: "物质英文名称",
    remark: "备注",
    reSubName: "物质名称重复，请重新输入！",
    reSubEname: "物质英文名称重复，请重新输入！", //substance
    substance: "物质种类",
    mainName: "主名称",
    viceName: "副名称",
    dynamic: "动态配置",
  },
  EN: { //英文翻译
    type: "VOC",
    vocReport: "Check report",
    vocCode: "Report code",
    vocOrg: "Check organization",
    createDate: " Date of manufacture",
    sendDate: "Sample date",
    checkDate: "Checking date",
    checkRule: "Checking rule",
    checkResult: "Checking result",
    analysis: "upload",
    voc: "VOC",
    component: " Component",
    semiComponent: " Semicomponent ",
    material: " Material",
    subsName: " Substance name",
    estimatedValue: " Estimated value",
    unit: " Unit",
    upload: "view",
    vocProject: "project",
    odor: "odor result",
    comfortability: "comfortability result",
    smellType: "smell type",
    vocMaterialAtomization: "Atomization",
    vocMaterialSmell: "smell",
    condensation: "condensation",
    atomization: "atomization",
    upload: "upload",
      /*菜单-VOC物质种类管理*/
    index: "No.",
    subName: "Substance name",
    subEname: "Substance English name",
    remark: "Remark",
    reSubName: "Substance name repeat, please re-enter!",
    reSubEname: "Substance English name repeat, please re-enter!",
    substance: "substance",
    mainName: "Main name",
    viceName: "Vice name",
    dynamic: "Dynamic",
  }
}
export default info //需要暴露出去
